// Types pour compatibilité avec l'ancien code
// Ces types ne sont plus utilisés avec Firebase natif mais conservés pour la compatibilité
export interface SnapshotAction<T> {
	payload: {
		val(): T;
		key: string | null;
	};
	key: string | null;
}

export interface DocumentChangeAction<T> {
	payload: {
		doc: {
			data(): T;
			id: string;
		};
	};
}


export class BaseFirebaseModel {

	static className: string = '';
	hash: string = '';
	uuid = '';
	path: unknown;
	parent: unknown;
	doc: unknown;
	add: unknown;
	metadata?: unknown;
	updatedAt: Date = new Date();
	createdAt: Date = new Date();

	constructor(uuid: string = '') {
		this.uuid = uuid;
		this.hash = window.crypto.randomUUID();
	}

	static fromObject(obj?: Record<string, unknown>) {
		return Object.assign(new this(), obj);
	}

	static fromFirebaseSnapshot(snap: DocumentChangeAction<unknown> | SnapshotAction<unknown>) {
		let bakedSnap: BaseFirebaseModel;

		if ((snap as DocumentChangeAction<unknown>).payload.doc) {
			snap = (snap as DocumentChangeAction<unknown>);
			const docData = snap.payload.doc.data();
			bakedSnap = this.fromObject({
				                            ...(typeof docData === 'object' && docData !== null ? docData as Record<string, unknown> : {}),
				                            uuid: snap.payload.doc.id
			                            });
		} else {
			snap = (snap as SnapshotAction<unknown>);
			const valData = snap.payload.val();
			bakedSnap = this.fromObject({
				                            ...(typeof valData === 'object' && valData !== null ? valData as Record<string, unknown> : {}),
				                            uuid: snap.key
			                            });
		}

		return bakedSnap;
	}

	static fromFirebaseSnapshots(snaps: DocumentChangeAction<unknown>[] | SnapshotAction<unknown>[]) {
		const bakedSnap: BaseFirebaseModel[] = [];

		snaps.forEach(snap => {
			if ((snap as DocumentChangeAction<unknown>).payload.doc) {
				snap = (snap as DocumentChangeAction<unknown>);
				const docData = snap.payload.doc.data();
				bakedSnap.push(this.fromObject({
					                               ...(typeof docData === 'object' && docData !== null ? docData as Record<string, unknown> : {}),
					                               uuid: snap.payload.doc.id
				                               }));
			} else {
				snap = (snap as SnapshotAction<unknown>);
				const valData = snap.payload.val();
				bakedSnap.push(this.fromObject({
					                               ...(typeof valData === 'object' && valData !== null ? valData as Record<string, unknown> : {}),
					                               uuid: snap.key
				                               }));
			}
		});
		return bakedSnap;
	}

	toFirebase() {
		const bfm = JSON.parse(JSON.stringify(this));
		delete bfm.uuid;
		return bfm;
	}
}
